import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

import type {
  UpdatePointsPurchaseOfferCampaignRequestBody,
  UpdatePointsPurchaseOfferRequestBody,
} from '~/types/loyaltyContract';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useCreatePointsPurchaseOffer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: LoyaltyService.createPointsPurchaseOffer,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: pointsPurchaseQueryKeys.offers() });
    },
  });
}

export function useUpdatePointsPurchaseOffer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ offerId, params }: { offerId: string; params: UpdatePointsPurchaseOfferRequestBody }) =>
      LoyaltyService.updatePointsPurchaseOffer(offerId, params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: pointsPurchaseQueryKeys.offers() });
    },
  });
}

export function useCreatePointsPurchaseOfferCampaign() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: LoyaltyService.createPointsPurchaseOfferCampaign,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: pointsPurchaseQueryKeys.campaigns() });
      await queryClient.invalidateQueries({ queryKey: pointsPurchaseQueryKeys.offers() });
    },
  });
}

export function useUpdatePointsPurchaseOfferCampaign() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      campaignId,
      params,
    }: {
      campaignId: string;
      params: UpdatePointsPurchaseOfferCampaignRequestBody;
    }) => LoyaltyService.updatePointsPurchaseOfferCampaign(campaignId, params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: pointsPurchaseQueryKeys.campaigns() });
      await queryClient.invalidateQueries({ queryKey: pointsPurchaseQueryKeys.offers() });
    },
  });
}
